import {
  addToCartClickOutcomes,
  addToCartClickSources,
  posthogEvents
} from '@/shared/constants/constants';
import { posthogLog } from '@/shared/pinia/modules/posthog/logger';

export type AddToCartClickSource =
  (typeof addToCartClickSources)[keyof typeof addToCartClickSources];
export type AddToCartClickOutcome =
  (typeof addToCartClickOutcomes)[keyof typeof addToCartClickOutcomes];

type AddToCartClickedData = {
  source: AddToCartClickSource;
  outcome: AddToCartClickOutcome;
  product_id: string | null;
  variant_id: number | null;
  quantity: number;
};

export const trackAddToCartClicked = (eventData: AddToCartClickedData) => {
  posthogLog('Tracking add to cart clicked event:', eventData);

  window.posthog?.capture(posthogEvents.ADD_TO_CART_CLICKED, eventData);
};
